import { WebappEnv } from '@/entities/webapp-env';
import { env } from '@/env';

export function EnvironmentBadge() {
  const webappEnv = env.VITE_WEBAPP_ENV;

  if (webappEnv === WebappEnv.PRODUCTION) {
    return null;
  }

  const config = getEnvConfig(webappEnv);

  return (
    <div
      className="flex items-center gap-1.5 rounded px-2 py-0.5 text-xs font-semibold"
      style={{
        backgroundColor: config.bgColor,
        color: config.textColor,
      }}
      title={`Environment: ${config.label}`}
    >
      <div
        className="size-1.5 animate-pulse rounded-full"
        style={{ backgroundColor: config.dotColor }}
      />
      <span>{config.label}</span>
    </div>
  );
}

function getEnvConfig(env: WebappEnv) {
  switch (env) {
    case WebappEnv.STAGING:
      return {
        label: 'STAGING',
        bgColor: '#FFF7ED',
        textColor: '#C2410C',
        dotColor: '#FF8C42',
      };
    case WebappEnv.SANDBOX:
      return {
        label: 'SANDBOX',
        bgColor: '#FAF5FF',
        textColor: '#7E22CE',
        dotColor: '#A855F7',
      };
    case WebappEnv.LOCAL:
    default:
      return {
        label: 'LOCAL',
        bgColor: '#EFF6FF',
        textColor: '#1E40AF',
        dotColor: '#3B82F6',
      };
  }
}
